import { KeyValuePipe } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { HideNodeActionPipe } from '@features/flow-ui-creator/pipes/hide-node-action.pipe';
import { NodeBackgroundColorPipe } from '@features/flow-ui-creator/pipes/node-background-color.pipe';
import { NodeIconPipe } from '@features/flow-ui-creator/pipes/node-icon.pipe';
import { NodeWarningTooltipPipe } from '@features/flow-ui-creator/pipes/node-warning-tooltip.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';
import { ReteModule } from 'rete-angular-plugin/21';
import { BaseNodeComponent } from '../base-node/base-node.component';
import { NodeSocketComponent } from '../node-socket/node-socket.component';

@Component({
  selector: 'app-terminal-node',
  imports: [
    ReteModule,
    NodeBackgroundColorPipe,
    NodeSocketComponent,
    NodeIconPipe,
    HideNodeActionPipe,
    KeyValuePipe,
    NodeWarningTooltipPipe,
    TooltipModule,
    TranslateModule,
  ],
  templateUrl: './terminal-node.component.html',
  styleUrls: ['./terminal-node.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    'data-testid': 'node',
  },
})
export class TerminalNodeComponent extends BaseNodeComponent {}
